var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _polygon2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _polygon3, _path45, _polygon4, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _polygon5, _path53, _path54, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _polygon6, _path85, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _path86, _polygon12, _path87, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path88, _polygon13, _path89, _polygon14, _path90, _polygon15, _path91, _path92;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2800.05 1703.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4f7fd;}.cls-2{fill:#102a54;}.cls-3{fill:#ffc0b1;}.cls-4{fill:#0c203f;}.cls-5{fill:#fff;}.cls-6{fill:#e6515c;}.cls-7{fill:#3c94f8;}.cls-8{fill:#80c0ff;}.cls-9{fill:#ffb841;}.cls-10{fill:#6cb597;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M593.74,702.54c27.21,30.2,57.74,31.93,109.64,50.28,77.92,27.56,177.1,110,128.85,203.46-19.4,37.56-61,58.8-102.36,67.65-83.87,18-174.65-7.55-237-66.36-53.27-50.2-84.48-123.5-83.31-196.78h0c.75-45.63,24.15-122.71,67.38-146.16,51.83-28.11,72.82,14.74,94.14,54.47C578.61,683.18,586,694,593.74,702.54Z",
    transform: "translate(-406.86 -179.71)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M855.63,355.52C783,449.75,725.2,596.9,803.7,705c48.08,66.21,142.45,103.21,217.85,60.38,59.5-33.79,83.09-100.6,119.1-154.69,39.61-59.49,89-89.82,155.76-113.15,84.27-29.45,226.91-103.21,152.51-215.35-15.42-23.25-38.34-40.58-62.46-54.62-145.42-84.65-331.18-50.72-458,52.39C903.13,300.54,878.13,326.35,855.63,355.52Z",
    transform: "translate(-406.86 -179.71)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1584.17,496.2c-108.77,99.29-81.57,268-151.92,389.5-19.65,33.93-44.48,65.34-57.5,102.32-27.39,77.78,26,149.37,102.79,164.06,75.07,14.37,160.46-10.41,226.71-45.36,150.49-79.38,202.37-268.13,221.56-425,7.19-58.74,3.75-121-24.66-172.9-63.58-116.17-217.37-93.53-306.33-21.76Q1589.29,491.53,1584.17,496.2Z",
    transform: "translate(-406.86 -179.71)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M984.05,961.81a87.17,87.17,0,0,0-12.75,23.56c-59,165.16,272.2,133.55,183.62-16.92C1119.17,907.71,1024.17,909,984.05,961.81Z",
    transform: "translate(-406.86 -179.71)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M445.36,1883.53H3098c16.92-128.59,6.15-248.7-16.52-376.4-11.2-63.13-27.36-125.85-55-183.69-30.76-64.33-75.18-121.38-124.83-172.56-115.43-119-263-209.11-425-244.35s-338.17-13.07-480.06,72.68C1817,1087.73,1688.76,1294,1481.82,1328.67c-79.76,13.37-161.22-1.54-240.81-15.87-125.61-22.62-254.82-43.88-380.09-19.41-126.6,24.73-243.23,97.37-321.25,200.08S435.24,1754.94,445.36,1883.53Z",
    transform: "translate(-406.86 -179.71)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M985.21,943l25,9.17,3.21,11.89,32,27.48a13.53,13.53,0,0,1,3.89,14.92h0l-81.55-29.88a6.61,6.61,0,0,1-3.94-8.48,6.83,6.83,0,0,1,.68-1.35Z",
    transform: "translate(-406.86 -179.71)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "610.56 750.85 603.39 772.43 578.36 763.26 582.7 744.61 610.56 750.85"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M640.4,1068.78l21.67,15.52-.07,12.31,23.47,35a13.55,13.55,0,0,1-.24,15.42h0l-70.61-50.57a6.61,6.61,0,0,1-1.53-9.22,6.32,6.32,0,0,1,1-1.12Z",
    transform: "translate(-406.86 -179.71)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "267.88 885.71 255.21 904.59 233.53 889.07 242.7 872.25 267.88 885.71"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M898.55,659.6c4.94-1.72,190.39-11.9,218.36,12.32s-92.7,266.5-92.7,266.5L980,930.56l57.4-196s-153.07,65.57-200.17,46-35.3-121-35.3-121Z",
    transform: "translate(-406.86 -179.71)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M801.93,659.6l-33.75,192L642.61,1053.43l33.1,18.26S819,909,834.06,895.69,937.83,679.54,937.83,679.54Z",
    transform: "translate(-406.86 -179.71)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M769.56,465.11l-58.64,24.68a103.55,103.55,0,0,0-13,6.58L566.34,574.89l11.4,24.43,144.64-59.55a75.64,75.64,0,0,1,7.58-2.66L781.67,522Z",
    transform: "translate(-406.86 -179.71)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M566.34,574.89s-23.49,3-25.07,6.38-7.68,22.81-7.68,24.93,15.19,15.18,20.84,14.48c2-.25,5.94-3.18,10.22-6.85a14.92,14.92,0,0,0,5.41.3c4-1.07,11.38-16.33,11.38-16.33S571.69,574.1,566.34,574.89Z",
    transform: "translate(-406.86 -179.71)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M564.65,614.88h-.22c-15.64-3.24-16.24-3.84-16.49-4.1a1.41,1.41,0,0,1-.31-1.45c.42-1.72,3.82-6.14,6.6-7,2.33-.72,9.26-.35,12.26-.14-.27-2.17-.68-6.55,0-9.62-2.94-.86-11.42-3.52-14.69-6.43a1.06,1.06,0,0,1,1.4-1.58c3.54,3.15,14.73,6.23,14.84,6.26a1,1,0,0,1,.66.52,1.09,1.09,0,0,1,.07.83c-1.16,3.47,0,10.92,0,11a1.06,1.06,0,0,1-.27.88,1.08,1.08,0,0,1-.86.34c-2.85-.23-10.71-.68-12.78,0-1.77.54-4.29,3.62-5,5,2.26.69,9.75,2.34,15,3.43a1.06,1.06,0,0,1,.82,1.25A1,1,0,0,1,564.65,614.88Z",
    transform: "translate(-406.86 -179.71)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M892.45,435.19h0a16.57,16.57,0,0,1-16.57-16.57c0-.43,0-.86,0-1.29l4.48-57.7h23.43L909,417.15a16.58,16.58,0,0,1-15.06,18C893.45,435.17,893,435.19,892.45,435.19Z",
    transform: "translate(-406.86 -179.71)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M876.08,311.52h74.1l-.62,4.59a240.75,240.75,0,0,0-1.75,48c.51,7.65,0,16.77-3.86,24.14-7.49,14.47-24.93,20.94-39.73,14.14S866.22,374,876.08,311.52Z",
    transform: "translate(-406.86 -179.71)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M924.52,365.74h-6.84a.78.78,0,1,1,0-1.56h6.84a1.87,1.87,0,0,0,1.88-1.86,1.81,1.81,0,0,0-.07-.52l-5.93-21.43a.78.78,0,0,1,1.48-.5s0,.05,0,.08l5.94,21.43a3.45,3.45,0,0,1-3.32,4.36Z",
    transform: "translate(-406.86 -179.71)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M912.13,342.38a3.76,3.76,0,1,1-3.76-3.76,3.76,3.76,0,0,1,3.76,3.76Z",
    transform: "translate(-406.86 -179.71)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M939,341.64a3.77,3.77,0,1,1-3.78-3.76h0A3.78,3.78,0,0,1,939,341.64Z",
    transform: "translate(-406.86 -179.71)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M907.76,404.49h-.24c-.44-.14-10.9-3.63-18.13-12.13a.78.78,0,0,1,.09-1.1h0a.77.77,0,0,1,1.09.08h0C897.51,399.51,907.9,403,908,403a.78.78,0,0,1-.24,1.52Z",
    transform: "translate(-406.86 -179.71)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M930.43,375.91c-.58-.11-13,.82-20.45-7.82,0,0-.49,10.63,7.7,12.85S930.43,375.91,930.43,375.91Z",
    transform: "translate(-406.86 -179.71)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M922.86,376h-.07c-7.81-.73-13.18-7.14-13.41-7.41a.79.79,0,0,1,.1-1.11.8.8,0,0,1,1.11.11c0,.06,5.2,6.18,12.34,6.84a.78.78,0,1,1-.07,1.56Z",
    transform: "translate(-406.86 -179.71)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M982.35,303.63a22.9,22.9,0,0,0-1.09-2.49c-3.35-6.54-9.6-11.3-16.45-13.72a43.12,43.12,0,0,0-11.46-2.3,47.26,47.26,0,0,0-5.83-.05c-.8,0-5.21,1-5.65.63-6.54-5.82-16.67-6.63-25.41-6.21-3.24.15-6.62.53-9.33,2.3a8.44,8.44,0,0,0-.91.66c-14.25-5.13-20.3,11-32.14,13.56-3.69.78-7.51-.18-11.27,0A18.29,18.29,0,0,0,850,302.47c-3.26,3.89-4.74,9-7.6,13.16-4.89,7.19-13.07,11.06-19.07,17.17-13.6,13.82-10.78,38.65-1.28,53.9,6.25,10,16.88,17.5,28.62,18.74s24.25-4.37,30.13-14.6c6.92-12,4-27,4.88-40.9.44-6.64,2.18-13.8,7.46-17.86,6-4.6,14.43-3.77,21.45-6.5a21.74,21.74,0,0,0,6.51-4,46.85,46.85,0,0,0,10,6.78c8,3.93,17.35,4.88,26.16,3.66,7.75-1.07,18.31-3.89,23.35-10.35C984.43,316.68,984.44,309.29,982.35,303.63Z",
    transform: "translate(-406.86 -179.71)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1187.77,334.68l-14.62-5.77a8.48,8.48,0,0,0-11,4.75,9.05,9.05,0,0,0-.39,1.25l-6.57,29.28-52.37,117.59-66.46-15.19-13.69,56,89.24,10.27a26.12,26.12,0,0,0,11-1.09h0a26.26,26.26,0,0,0,17.37-18.34l36.62-139.66,13.87-19.9,2.34-11.29A8.47,8.47,0,0,0,1187.77,334.68Z",
    transform: "translate(-406.86 -179.71)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1184.57,361.92h-.17a.76.76,0,0,1-.59-.91v0l2.64-11.63a1.62,1.62,0,0,1,3-.3l2,4.51a.78.78,0,1,1-1.43.64l-2-4.52-2.74,11.65A.77.77,0,0,1,1184.57,361.92Z",
    transform: "translate(-406.86 -179.71)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1114.4,506.09a1,1,0,0,1-1-.59l-11.59-23.21a1.07,1.07,0,1,1,1.9-1h0l11.59,23.22a1.06,1.06,0,0,1-.46,1.43h0A1.11,1.11,0,0,1,1114.4,506.09Z",
    transform: "translate(-406.86 -179.71)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M937.88,427s-46.18-18.25-62-12.09h0l-.66.27L757.3,464.43l14.91,67.93,70.4-13.15c-1.53,7.19-2.87,14.1-3.92,20.47a199.19,199.19,0,0,1-20.46,60.8l-42.7,80.81C767.79,720.8,937,716.43,937,716.43c32-31.37,40-187.29,40-187.29l72,4,13.24-65.82Z",
    transform: "translate(-406.86 -179.71)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M842.61,520.27h-.23a1.07,1.07,0,0,1-.81-1.28h0c.11-.48,10.9-48.36,19-72.31a1.07,1.07,0,0,1,2,.68c-8,23.85-18.79,71.62-18.9,72.1A1.06,1.06,0,0,1,842.61,520.27Z",
    transform: "translate(-406.86 -179.71)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M985.08,530.5H985l-38.3-2.07a1.07,1.07,0,0,1-.06-2.14h.17l38.31,2.07a1.07,1.07,0,0,1-.06,2.13Z",
    transform: "translate(-406.86 -179.71)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1022,862.94l-15.48,2.32L961.8,851.39a2,2,0,0,0-2.51,1.3,1.64,1.64,0,0,0-.09.44h0a7.46,7.46,0,0,0,3.35,6.92l12.73,8.29-40.59-.75a9.93,9.93,0,0,0-10.52,9.3,9.48,9.48,0,0,0,0,1.41l1,12.33a9.93,9.93,0,0,0,7.07,8.72l28.32,8.4a10.05,10.05,0,0,0,5.7,0l46.83-14.15,13.07-.86Z",
    transform: "translate(-406.86 -179.71)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M981.31,889.29a1,1,0,0,1-.69-.27c-7-6.66-6.37-20.17-6.34-20.74a1,1,0,1,1,2,.11c0,.13-.65,13.16,5.72,19.18a1,1,0,0,1-.69,1.72Z",
    transform: "translate(-406.86 -179.71)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1409.55,567.5l37.85,4.92a21.66,21.66,0,0,1,18.85,20.17c.75,12.29,2,28.21,4,38.5,1.76,9,2.5,19.87-.91,29.19-6.68,18.27-26.35,28.58-44.91,22.77-16.66-5.23-43.59-30.88-41-93.64a23.11,23.11,0,0,1,24.09-22.09C1408.2,567.35,1408.88,567.41,1409.55,567.5Z",
    transform: "translate(-406.86 -179.71)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1393.81,726.54h0a21.19,21.19,0,0,1-18-24c.08-.55.18-1.1.3-1.64l16.27-72.25,29.67,4.3-4.1,73.78a21.19,21.19,0,0,1-22.33,20Q1394.74,726.68,1393.81,726.54Z",
    transform: "translate(-406.86 -179.71)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1436,635.26a1,1,0,1,1-.13-2l8.69-1.12a2.41,2.41,0,0,0,1.91-3.31l-11-26.24a1,1,0,1,1,1.85-.77l11,26.24a4.4,4.4,0,0,1-3.5,6.07l-8.69,1.11Z",
    transform: "translate(-406.86 -179.71)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1425.26,606.51a4.81,4.81,0,1,1-5.39-4.17A4.81,4.81,0,0,1,1425.26,606.51Z",
    transform: "translate(-406.86 -179.71)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1459.21,601.2a4.81,4.81,0,1,1-5.39-4.16A4.81,4.81,0,0,1,1459.21,601.2Z",
    transform: "translate(-406.86 -179.71)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1425.55,599.35l-19.64,2.51a2.64,2.64,0,0,1-3-2.23v0h0a2.66,2.66,0,0,1,2.25-3h0l19.64-2.51a2.64,2.64,0,0,1,3,2.23v.05h0a2.64,2.64,0,0,1-2.25,3Z",
    transform: "translate(-406.86 -179.71)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1463.35,593.49,1443.71,596a2.62,2.62,0,0,1-3-2.21s0,0,0-.07h0a2.64,2.64,0,0,1,2.23-3h0l19.65-2.51a2.62,2.62,0,0,1,3,2.21s0,.05,0,.07h0a2.64,2.64,0,0,1-2.23,3Z",
    transform: "translate(-406.86 -179.71)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1425.41,640.15s12.9,6.05,26.8,5.31C1452.21,645.46,1437,662.68,1425.41,640.15Z",
    transform: "translate(-406.86 -179.71)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1444.27,646.21h-.09a50.62,50.62,0,0,1-20.46-6.34,1,1,0,0,1,1-1.7,49.82,49.82,0,0,0,19.6,6.06,1,1,0,1,1-.09,2Z",
    transform: "translate(-406.86 -179.71)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1395.18,547.67S1414.35,519.46,1439,533s56.19,40.08,56.19,40.08-21,18-28.93,19.52-65-18.83-65-18.83L1385.88,627s-23.65-41.63-20.67-57.84S1395.18,547.67,1395.18,547.67Z",
    transform: "translate(-406.86 -179.71)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1395.87,621.75c2.29,9.57-.4,18.43-6,19.77s-12-5.33-14.32-14.9.41-18.43,6-19.77S1393.58,612.18,1395.87,621.75Z",
    transform: "translate(-406.86 -179.71)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1419.43,682.4a.88.88,0,0,1-.39-.08c-.43-.18-10.46-4.57-17.11-17.49a1,1,0,0,1,1.77-.91c6.31,12.24,16,16.52,16.12,16.57a1,1,0,0,1-.39,1.91Z",
    transform: "translate(-406.86 -179.71)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1390.38,631.53h-.05a1,1,0,0,1-.95-1c.5-10.42-8.22-19.33-8.3-19.42a1,1,0,0,1,1.3-1.52.57.57,0,0,1,.11.11c.39.39,9.42,9.63,8.88,20.93A1,1,0,0,1,1390.38,631.53Z",
    transform: "translate(-406.86 -179.71)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1758.77,822.81l-174.27-8.73a24,24,0,0,1-11-3.72l-156-100v.18L1384.17,701l-46.81,323,127,29s13.9-120.21,12.27-204l66.49,23.8a107.75,107.75,0,0,0,47,5.75l169.09-17.07Z",
    transform: "translate(-406.86 -179.71)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1713.91,1481.42l26.55-13.66,12.23,6.36,46.9-5.49a15.19,15.19,0,0,1,15.25,8.13h0l-86.5,44.51a7.4,7.4,0,0,1-10-3.2,7.8,7.8,0,0,1-.59-1.57Z",
    transform: "translate(-406.86 -179.71)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1318.42 1269.04 1333.6 1288.05 1307.05 1301.71 1290.7 1284.04 1318.42 1269.04"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1103.34,1447.28l16.21,25.08-5.13,12.8,10.08,46.12a15.17,15.17,0,0,1-6.58,16h0l-52.82-81.69a7.41,7.41,0,0,1,3.71-11Z",
    transform: "translate(-406.86 -179.71)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "730.11 1275.67 712.69 1292.65 696.48 1267.57 712.46 1249.56 730.11 1275.67"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1262.12,1007.52l8.22,230.37-164.48,193.42L1141,1462.9l196.25-152.81a107.22,107.22,0,0,0,32.65-42.3h0a106.92,106.92,0,0,0,7.8-28.4l27.65-211.11Z",
    transform: "translate(-406.86 -179.71)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1445,1022.49l154.81,178.61,141.87,245.56-55.51,33.15-153.9-217.19-187.55-138.1s-89.55-16.15-75.79-133Z",
    transform: "translate(-406.86 -179.71)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1388.54,1156.82l5.6-64s55,108.67,54,107.89S1388.54,1156.82,1388.54,1156.82Z",
    transform: "translate(-406.86 -179.71)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1376.42,698.63s28.37,13.14,41.16,11.72c0,0,31.85,47.43,39.88,95.84,9.79,58.95-12.51,216.3-12.51,216.3l-151.11-18.66Z",
    transform: "translate(-406.86 -179.71)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1417.58,710.35c-1.45,0-44-12.5-44-12.5s23.67,24.62,32.35,24.73S1417.58,710.35,1417.58,710.35Z",
    transform: "translate(-406.86 -179.71)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1397.05,714a36.74,36.74,0,0,0-55.45-7.44c-.58.53-1.15,1.08-1.73,1.63l-141.38,100.1a45.86,45.86,0,0,1-14.3,6.78L1011,855l8.09,42.21,184.31-15.87a116.35,116.35,0,0,0,32.89-8.63l44-18.79c-4.94,24.94-7,42.61-7,42.61l-64.42,133.82,165.64,57.49s33.37-177.4,44-238.54C1426,806.47,1416.88,744.79,1397.05,714Z",
    transform: "translate(-406.86 -179.71)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1280.35,854.91a1,1,0,0,1-.45-1.89l76-38.29a1,1,0,0,1,.9,1.78l-76,38.29A1,1,0,0,1,1280.35,854.91Z",
    transform: "translate(-406.86 -179.71)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "965.72 811.47 898.72 787.93 896.28 794.5 962.99 818.47 965.72 811.47"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1414.61,709.51S1438.42,828.24,1360,904.1l-5.35,37,35.45-18.37s77.75-101.42,27.49-212.34Z",
    transform: "translate(-406.86 -179.71)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1476.58,850h0a1,1,0,0,1-1-1c0-.39.08-39.9-8.56-62a1,1,0,0,1,.56-1.29,1,1,0,0,1,1.3.56h0c8.78,22.41,8.7,62.29,8.7,62.69a1,1,0,0,1-1,1Z",
    transform: "translate(-406.86 -179.71)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1757.65,
    y: 796.91,
    width: 134.77,
    height: 95.76,
    rx: 6.29,
    transform: "translate(155.32 2230.22) rotate(-75.94)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1768.94,
    y: 805.02,
    width: 111.38,
    height: 78.37,
    transform: "translate(155.58 2229.38) rotate(-75.94)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1832.41,
    y: 769.04,
    width: 5.59,
    height: 65.91,
    transform: "translate(204.54 2207.68) rotate(-75.94)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1829.49,
    y: 780.72,
    width: 5.59,
    height: 65.91,
    transform: "translate(191 2213.69) rotate(-75.94)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1826.56,
    y: 792.4,
    width: 5.59,
    height: 65.91,
    transform: "translate(177.45 2219.69) rotate(-75.94)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1823.64,
    y: 804.08,
    width: 5.59,
    height: 65.91,
    transform: "translate(163.91 2225.7) rotate(-75.94)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1820.7,
    y: 815.76,
    width: 5.59,
    height: 65.91,
    transform: "translate(150.35 2231.69) rotate(-75.94)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1817.78,
    y: 827.44,
    width: 5.59,
    height: 65.91,
    transform: "translate(136.81 2237.7) rotate(-75.94)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1814.86,
    y: 839.11,
    width: 5.59,
    height: 65.91,
    transform: "translate(123.28 2243.71) rotate(-75.94)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1811.93,
    y: 850.79,
    width: 5.59,
    height: 65.91,
    transform: "translate(109.74 2249.7) rotate(-75.94)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1830.69,
    y: 768.26,
    width: 19.29,
    height: 30.94,
    rx: 1.41,
    transform: "translate(226.14 2198.83) rotate(-75.94)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1758.82,827.16l19.81-7.34a10.73,10.73,0,0,1,7.37,0l26.56,9.5a2.13,2.13,0,0,1,1.28,2.71,2.15,2.15,0,0,1-.65.92l-1.69,1.39a8.78,8.78,0,0,1-5.23,2l-28.68,1-5.91,23.58-12.54-5.62Z",
    transform: "translate(-406.86 -179.71)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M877.33,954.63c6.95-3.5,15-4.11,22.77-4.15,7,0,14.08.37,20.8,2.31s13.13,5.55,17.47,11c5.7,7.19,7.31,16.79,7.61,26s-.51,18.44,1.18,27.46c1.61,8.62,5.48,16.91,5.3,25.68-.21,10.34-6,19.61-10,29.16a87.63,87.63,0,0,0-6.68,36.39,38.45,38.45,0,0,0-20.23-4.14c-4.35.32-8.74,1.38-13,.54-4.61-.9-8.49-3.89-12.52-6.3s-8.87-4.35-13.35-2.92c-4.25-11-4.33-23.74-3.93-35.56.44-13,.88-26,2.72-38.93.77-5.39,1.79-10.74,2.34-16.15a170.57,170.57,0,0,0,.63-18.64C878.42,975.78,877.62,965.22,877.33,954.63Z",
    transform: "translate(-406.86 -179.71)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M975.91,1410l-3.43,27.75a6.67,6.67,0,0,1-7.45,5.81,6.39,6.39,0,0,1-1.55-.38l-43-16.27V1410Z",
    transform: "translate(-406.86 -179.71)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M816.49,1412.26l296.6-4.21a13.23,13.23,0,0,0,13-13.42l-2.72-191.76a13.24,13.24,0,0,0-13.42-13L813.39,1194a13.24,13.24,0,0,0-13,13.42l2.72,191.75A13.24,13.24,0,0,0,816.49,1412.26Z",
    transform: "translate(-406.86 -179.71)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M962.75,1296.29a29.27,29.27,0,0,1-15.67-4.54l-144.73-91.46a.78.78,0,0,1,.84-1.32l144.72,91.47a27.82,27.82,0,0,0,30.35-.44l142.06-95.53a.77.77,0,0,1,1.07.2h0a.77.77,0,0,1-.21,1.08L979.13,1291.3A29.4,29.4,0,0,1,962.75,1296.29Z",
    transform: "translate(-406.86 -179.71)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M735.87,1343.89l47.75-211.73a35.37,35.37,0,0,1,40.43-29.45h0l86.26,13.56a35.36,35.36,0,0,1,27.09,21.18h0l29.15,54.42-30.44.43-18.47,180.19Z",
    transform: "translate(-406.86 -179.71)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M833.44,1103.37c-2.9,18.48,9.79,35.35,28.27,38.26s35.75-9.25,38.65-27.73Z",
    transform: "translate(-406.86 -179.71)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M864.42,1129.48h0A19.78,19.78,0,0,0,887,1113q.12-.77.18-1.53l5.41-68.86L865,1038.29l-16.7,66.86a19.78,19.78,0,0,0,14.38,24C863.26,1129.27,863.84,1129.39,864.42,1129.48Z",
    transform: "translate(-406.86 -179.71)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M849.21,971.44l87.37,13.75-1.58,5.3a286.07,286.07,0,0,0-11,56.21c-.82,9.12-3.16,19.77-9,27.76-11.51,15.66-33.28,20.06-49.46,9.29S826,1043.26,849.21,971.44Z",
    transform: "translate(-406.86 -179.71)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M896.92,1044.4a3.49,3.49,0,0,1-.65-.05l-8.07-1.27a.93.93,0,0,1-.78-1.06.94.94,0,0,1,1.07-.78h0l8.07,1.27a2.25,2.25,0,0,0,2.57-1.86,2.41,2.41,0,0,0,0-.6l-3-26.38a.93.93,0,0,1,1.85-.21h0l3,26.37a4.11,4.11,0,0,1-3.62,4.54,3.4,3.4,0,0,1-.45,0Z",
    transform: "translate(-406.86 -179.71)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M886,1014.52a4.49,4.49,0,1,1-3.74-5.13h0a4.47,4.47,0,0,1,3.74,5.11Z",
    transform: "translate(-406.86 -179.71)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M917.77,1018.62a4.49,4.49,0,1,1-3.74-5.13h0a4.47,4.47,0,0,1,3.74,5.11Z",
    transform: "translate(-406.86 -179.71)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M871.76,1007.93a2.46,2.46,0,0,1-2.48-2.46,2.44,2.44,0,0,1,.82-1.85c8.95-8,20.45-.83,20.94-.52a2.48,2.48,0,0,1-2.67,4.17c-.36-.22-8.83-5.48-15,0A2.42,2.42,0,0,1,871.76,1007.93Z",
    transform: "translate(-406.86 -179.71)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M904.26,1010.74a2.48,2.48,0,0,1-1.66-4.32c8.95-8,20.45-.82,20.94-.51a2.48,2.48,0,0,1-2.43,4.33l-.24-.16c-.36-.23-8.83-5.48-15,0A2.47,2.47,0,0,1,904.26,1010.74Z",
    transform: "translate(-406.86 -179.71)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M884.53,1052.57s11,5.12,20.29.4c0,0,1.49,11.44-10,10.54S884.53,1052.57,884.53,1052.57Z",
    transform: "translate(-406.86 -179.71)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M892.49,1064.09h-.26a11.17,11.17,0,0,1-8.63-11.58l.13-1.23,1.15.47c12,4.93,19.38.52,19.45.47a.93.93,0,0,1,1,1.58c-.32.19-7.65,4.68-19.86.17.18,2.2,1.3,6.61,7.28,8.33a.93.93,0,0,1-.25,1.83Z",
    transform: "translate(-406.86 -179.71)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M867.29,1143.71c-1.64,0-3.36-.08-5.16-.26a.93.93,0,0,1,.19-1.86c32.91,3.29,37.45-25.7,37.63-26.93a.92.92,0,0,1,1-.79h0a.93.93,0,0,1,.79,1.05C901.75,1115.22,897.34,1143.71,867.29,1143.71Z",
    transform: "translate(-406.86 -179.71)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M979.94,1542.67c-4.37-27.79-62.28-170.19-62.28-170.19l-69.95-11-111.84-17.59c-28.5,18.74-38.28,192.38-38.28,192.38L570.77,1786l44.44,18.5S782.14,1575.9,792,1552.12c4.51-10.88,16.56-51.73,28.31-92.85,30.45,58.26,74.39,103.15,74.39,103.15l-6.34,260h47.78S984.3,1570.46,979.94,1542.67Z",
    transform: "translate(-406.86 -179.71)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M820.3,1459.27l6.12-42.23,37,108.59S828.61,1480.89,820.3,1459.27Z",
    transform: "translate(-406.86 -179.71)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M922.41,1120.51l13.72,71.78h44.09S951.3,1128.21,922.41,1120.51Z",
    transform: "translate(-406.86 -179.71)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M847.71,1282.76c-3-9-27.17-181.6-27.17-181.6s-35.78,2.21-57.76,37C742.84,1169.69,682.59,1417,682.59,1417s93.22-10.3,103.25-16.25c3.21-1.91,7.93-33.37,12.85-75.23a50.74,50.74,0,0,0,11.59,11.3h0a50.52,50.52,0,0,0,22.12,8.7l139.18,19.26,8.63-32.51S850.66,1291.8,847.71,1282.76Z",
    transform: "translate(-406.86 -179.71)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M979.58,1334.69l3.8,1.24a7.89,7.89,0,0,0,4.49.14c5.69-1.47,18.13-6.75,20.07-6,2.41.87,20.54,11.45,19,16.65-.56,1.89-9.36,19.54-15.93,20s-20.79,1.32-23.42,0-14.94-5.84-14.94-5.84Z",
    transform: "translate(-406.86 -179.71)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1025.11,1351.35h-5.77a.78.78,0,0,1,0-1.56h5.77a.78.78,0,0,1,0,1.56Z",
    transform: "translate(-406.86 -179.71)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1020.93,1357.25h-5.77a.78.78,0,0,1,0-1.56h5.77a.78.78,0,1,1,0,1.56Z",
    transform: "translate(-406.86 -179.71)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1016.62,1363.14h-5.78a.78.78,0,0,1-.78-.78h0a.76.76,0,0,1,.77-.77h5.79a.76.76,0,0,1,.77.75v0a.76.76,0,0,1-.76.78Z",
    transform: "translate(-406.86 -179.71)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M798.69,1326.33a.76.76,0,0,1-.62-.31,126.85,126.85,0,0,1-16.56-33.12c-6.25-19.19-18.26-71.3-18.38-71.82a.78.78,0,0,1,1.51-.38v0c.12.52,12.11,52.56,18.34,71.69a125.27,125.27,0,0,0,16.33,32.67.78.78,0,0,1-.16,1.09A.8.8,0,0,1,798.69,1326.33Z",
    transform: "translate(-406.86 -179.71)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M904.92,980.22A19.85,19.85,0,0,1,890.7,990c-5.49.8-11.31-.73-16.52,1.18-6.17,2.27-9.73,8.73-11.64,15s-2.8,13-6.13,18.67c-2.76,4.69-7.12,8.51-8.77,13.71-1.31,4.15-.69,8.65.17,12.92a117.46,117.46,0,0,0,4.38,15.83,95.5,95.5,0,0,1,3.87,12.09,32.33,32.33,0,0,1-2.08,19.17,37.87,37.87,0,0,0-18.91-7.75c-4.76-.55-9.75-.22-14.13-2.15-6.74-3-10.22-10.34-12.72-17.26a28.78,28.78,0,0,0-3.34-7.23c-3-4.08-7.9-6.11-12.22-8.72s-8.53-6.75-8.24-11.78a14.12,14.12,0,0,1,.21-1.59,31.18,31.18,0,0,1,7.84-15.4c4.35-4.73,9-9.27,13.06-14.05,8.31-9.8,13.55-21.78,20.28-32.73s15.76-21.44,28-25.23A45.21,45.21,0,0,1,864,952.93a33.82,33.82,0,0,1,10.33.67c8.73,2.18,15.24,9.24,21.22,16C899,973.39,901.52,976.4,904.92,980.22Z",
    transform: "translate(-406.86 -179.71)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M903,974.73c-.09,5.63.13,12,4.31,15.76a18.6,18.6,0,0,0,4.87,2.89c4.54,2.07,9.43,4.13,12.33,8.19,2.2,3.08,3,6.92,4.19,10.49s3.26,7.25,6.77,8.66c6.45-8.53,8.25-19.69,8.45-30.38.09-5-.06-10.1-2.15-14.6-2.42-5.19-7.18-8.94-12.23-11.63a25.89,25.89,0,0,0-8.81-3.1C912.44,959.94,903.18,966.33,903,974.73Z",
    transform: "translate(-406.86 -179.71)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M882.72,1091c-5.31,0-12.51-1.2-17.84-6.63a.93.93,0,0,1,1.33-1.3c8.59,8.74,23.13,5.41,23.27,5.37a.94.94,0,0,1,1.13.69,1,1,0,0,1-.69,1.13A34.17,34.17,0,0,1,882.72,1091Z",
    transform: "translate(-406.86 -179.71)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M896.86,1837l29.83,1.47,7.39,11.64,43.34,18.74a15.18,15.18,0,0,1,9.13,14.67h0l-97.16-4.8a7.38,7.38,0,0,1-6.75-9.42Z",
    transform: "translate(-406.86 -179.71)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "521.56 1642.69 519.82 1658.77 490 1657.3 489.92 1642.69 521.56 1642.69"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M571.64,1802.85l27.94,10.53,3.48,13.34,35.52,31.1a15.16,15.16,0,0,1,4.21,16.76h0l-91-34.3a7.38,7.38,0,0,1-3.55-11Z",
    transform: "translate(-406.86 -179.71)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "199.29 1620.97 192.72 1633.67 164.78 1623.14 170.05 1608.8 199.29 1620.97"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "641.31 1442.45 730.15 1441.92 818.98 1441.62 996.64 1441.36 1174.3 1441.61 1263.13 1441.92 1351.96 1442.45 1263.13 1442.98 1174.3 1443.28 996.64 1443.53 818.98 1443.28 730.15 1442.97 641.31 1442.45"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "931 1230.29 1045.93 1229.76 1160.86 1229.46 1390.73 1229.2 1620.59 1229.45 1735.52 1229.76 1850.46 1230.29 1735.52 1230.82 1620.59 1231.12 1390.73 1231.37 1160.86 1231.12 1045.93 1230.82 931 1230.29"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "655.32 1380.15 573.41 1380.68 491.49 1380.98 327.66 1381.23 163.83 1380.98 81.92 1380.68 0 1380.15 81.92 1379.62 163.83 1379.32 327.66 1379.07 491.49 1379.32 573.41 1379.62 655.32 1380.15"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1380.74 1055.5 1298.83 1056.03 1216.91 1056.33 1053.08 1056.58 889.26 1056.33 807.34 1056.03 725.43 1055.5 807.34 1054.97 889.26 1054.67 1053.08 1054.42 1216.91 1054.67 1298.83 1054.97 1380.74 1055.5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M587.26,819.15c14.72-.24,29.44-.35,44.16-.53l44.15-.3c29.44-.18,58.88-.16,88.32-.25l88.31.25,44.16.3c14.72.18,29.43.28,44.15.53-14.72.25-29.43.35-44.15.53l-44.16.3-88.31.25c-29.44-.09-58.88-.07-88.32-.25l-44.15-.3C616.7,819.5,602,819.39,587.26,819.15Z",
    transform: "translate(-406.86 -179.71)"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "459.84 438.53 514.39 438 568.95 437.7 678.06 437.44 787.17 437.69 841.73 438 896.28 438.53 841.73 439.06 787.17 439.36 678.06 439.61 568.95 439.36 514.39 439.05 459.84 438.53"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M535.07,684.67c11.64-.24,23.28-.35,34.92-.53l34.92-.3c23.27-.18,46.55-.16,69.83-.25,23.28.08,46.56.07,69.84.25l34.92.3c11.64.18,23.28.28,34.92.53-11.64.25-23.28.35-34.92.53l-34.92.31c-23.28.17-46.56.16-69.84.24-23.28-.09-46.56-.07-69.83-.25L570,685.2C558.35,685,546.71,684.91,535.07,684.67Z",
    transform: "translate(-406.86 -179.71)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 2729.11,
    cy: 1119.07,
    rx: 658.79,
    ry: 274,
    transform: "translate(745.84 3432.41) rotate(-79.99)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 2681.13,
    cy: 1110.61,
    rx: 658.79,
    ry: 274,
    transform: "translate(714.54 3378.18) rotate(-79.99)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 2659.19,
    cy: 1105.56,
    rx: 402.11,
    ry: 167.24,
    transform: "translate(701.38 3352.39) rotate(-79.99)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 2638.87,
    cy: 1100.47,
    rx: 198.01,
    ry: 82.35,
    transform: "translate(689.6 3328.19) rotate(-79.99)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2640.35,1097.44h-.25l-508.78-49.92a2.55,2.55,0,1,1,.5-5.08l508.77,49.92a2.55,2.55,0,0,1-.24,5.09Z",
    transform: "translate(-406.86 -179.71)"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1739.96 836.32 1758 867.23 1733.82 893.61 1616.87 881.05 1641.06 854.68 1623.02 823.77 1739.96 836.32"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2637.37,1055.77a2.19,2.19,0,0,1-.67-.11l-411-132.72a2.16,2.16,0,1,1,1.06-4.19l.27.09,411,132.72a2.16,2.16,0,0,1-.66,4.21Z",
    transform: "translate(-406.86 -179.71)"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1837.34 720.04 1846.66 748.79 1821.96 766.21 1727.69 734.82 1752.39 717.4 1743.07 688.64 1837.34 720.04"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2133.12,1196.73a2.55,2.55,0,0,1-.37-5.08l505.67-75.16a2.56,2.56,0,0,1,.75,5.06L2133.5,1196.7Z",
    transform: "translate(-406.86 -179.71)"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1717.4 987.36 1742.84 1012.53 1726.33 1044.28 1610.13 1062.52 1626.64 1030.77 1601.2 1005.6 1717.4 987.36"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2818.32,1883.53s349.25-185.58,388.59-378c0,0-194.66,87.66-382.09,249.7,0,0,172.85-130.58,172.85-338.24,0,0-212.39,178.53-295.77,322.51,0,0,22-189.62-26.75-282.81,0,0-83.38,134.93-64.5,314.27,0,0-86.21-96-210.66-138.44,0,0,34.46,155.75,133.57,195.08,0,0-114.84-45.62-229.69-39.33,0,0,40,95.21,138.44,95.21Z",
    transform: "translate(-406.86 -179.71)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2611.48,1883.53s-40.93-21.77-74-110.77c0,0,78.71,26.44,112.44,55.38,0,0,47.78-68.5,119.92-126.59,0,0,21.55,80.57-28.1,138.66,0,0,89.14-46,241.32-62.37,0,0-57.68,87.16-143.88,105.69Z",
    transform: "translate(-406.86 -179.71)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskA);
export default __webpack_public_path__ + "static/media/task-a.ec78afcb5bcc67ce3bcb559f6eaab34c.svg";
export { ForwardRef as ReactComponent };